import { Box, Chip, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import React from 'react';

const AiSuggestions = ({
  suggestedLabels,
  suggestedModule,
  suggestedTechnologyLayer,
  labels,
  modules,
  technologyLayers,
  onAcceptLabel,
  onDismissLabel,
  onAcceptModule,
  onDismissModule,
  onAcceptTechLayer,
  onDismissTechLayer,
}) => {
  const hasAnySuggestion = suggestedLabels.length > 0 || suggestedModule || suggestedTechnologyLayer;
  if (!hasAnySuggestion) return null;

  return (
    <Box sx={{ mb: 2, p: 1.5, bgcolor: 'primary.50', border: '1px solid', borderColor: 'primary.200', borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
        <AutoAwesomeIcon sx={{ fontSize: 16, color: 'primary.main' }} />
        <Typography variant="caption" fontWeight={600} color="primary.main">
          AI Suggestions — click a chip to accept, ✕ to dismiss
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {suggestedLabels.map((labelId) => {
          const label = labels.find((l) => l.id === labelId);
          if (!label) return null;
          return (
            <Chip
              key={labelId}
              label={`Label: ${label.name}`}
              size="small"
              color="primary"
              variant="outlined"
              onClick={() => onAcceptLabel(labelId)}
              onDelete={() => onDismissLabel(labelId)}
              sx={{ cursor: 'pointer' }}
            />
          );
        })}
        {suggestedModule && (() => {
          const mod = modules.find((m) => m.id === suggestedModule);
          if (!mod) return null;
          return (
            <Chip
              key="module-chip"
              label={`Module: ${mod.name}`}
              size="small"
              color="secondary"
              variant="outlined"
              onClick={onAcceptModule}
              onDelete={onDismissModule}
              sx={{ cursor: 'pointer' }}
            />
          );
        })()}
        {suggestedTechnologyLayer && (() => {
          const tech = technologyLayers.find((t) => t.id === suggestedTechnologyLayer);
          if (!tech) return null;
          return (
            <Chip
              key="tech-chip"
              label={`Tech Layer: ${tech.name}`}
              size="small"
              color="success"
              variant="outlined"
              onClick={onAcceptTechLayer}
              onDelete={onDismissTechLayer}
              sx={{ cursor: 'pointer' }}
            />
          );
        })()}
      </Box>
    </Box>
  );
};

export default AiSuggestions;